module.exports = __webpack_public_path__ + "static/media/HumanBody-HealthBased-Illustration.cff73929.svg";